import React from 'react';
import ColorsListItem from './ColorsListItem';
import PropTypes from 'prop-types';

const ColorListBox = props => {
  const { title, colorsList, changeMaterial, activeValue, propClass, popupFunc } = props;

  return (
    <div className={`color-list ${propClass ? propClass : null}`}>
      <p className="color-list__title">{title}</p>
      <ColorsListItem
        colorName={activeValue}
        colorsList={colorsList}
        changeMaterial={changeMaterial}
      />
      {!!popupFunc && (
        <button className="popup-button" onClick={popupFunc}>
          <span className="icon-info" />
        </button>
      )}
    </div>
  );
};

ColorListBox.propTypes = {
  title: PropTypes.string,
  colorsList: PropTypes.array,
  activeValue: PropTypes.string,
  propClass: PropTypes.string,
  popupFunc: PropTypes.func,
};

export default ColorListBox;
